"use client";
import React, { useState } from "react";
import { IoChevronDown } from "react-icons/io5";

export const MobileDropDown = ({ title, children }) => {
    const [active, setActive] = useState(false);

    return (
        <div className="flex flex-col items-start gap-1">
            <div
                className="flex items-center gap-1"
                  onClick={() => {
                    setActive(active ? false : true);
                }}
            >
                {title}
                <IoChevronDown
                    className={`mt-1 transition-all duration-150 ${
                        active ? "rotate-180" : "rotate-0"
                    }`}
                />
            </div>

            <div
                className={`transition-all duration-50 my-3 ${
                     active ? "block opacity-100" : "hidden opacity-0"
                }`}
            >
                {children}
            </div>
        </div>
    );
};